/* ONE LIFE — motion layer (Phase 3, 2026-07)
   Scroll-staged reveals for main-content sections. Progressive
   enhancement: the reveal class is only ever added by JS, so without
   JS (or with reduced-motion) everything renders static and visible.
   Sections already in the first viewport are marked in immediately so
   the arrival never flashes. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // A transformed ancestor changes fixed-position drawers from viewport to
  // section coordinates. Keep overlay-owning sections static and visible.
  // Custom fixed overlays can opt out with data-ol-fixed-overlay as well.
  var overlaySelector = 'menu-drawer,header-drawer,cart-drawer,modal-dialog,product-modal,quick-add-modal,[role="dialog"],[data-ol-fixed-overlay]';
  var sections = Array.from(document.querySelectorAll('#MainContent .shopify-section')).filter(function (s) {
    return !s.hasAttribute('data-ol-fixed-overlay') && !s.querySelector(overlaySelector);
  });
  if (!sections.length || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ol-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

  // Measure the untransformed document once, before reveal classes write styles.
  // Interleaving these reads with each section's classes forces repeated layout.
  var firstViewportLimit = window.innerHeight * 0.92;
  var inFirstViewport = Array.from(sections, function (s) {
    return s.getBoundingClientRect().top < firstViewportLimit;
  });
  sections.forEach(function (s, index) {
    s.classList.add('ol-rv');
    if (inFirstViewport[index]) {
      s.classList.add('ol-in');
    } else {
      io.observe(s);
    }
  });
})();
